import React from 'react'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import * as SideMenu from 'components/side-menu'
import { GraduationCap } from '@phosphor-icons/react'
import { observer } from 'mobx-react-lite'
import { store } from 'store/index'

export const CareerCoachLink = observer(() => {
  const path = `/coach`
  const title = 'Coach'

  const isActive = useIsActive(path)

  // Only show if either user or org has AI coach enabled
  if (
    !store.currentUser?.aiCoachEnabled &&
    !store.currentUser?.org?.aiCoachEnabled
  ) {
    return null
  }

  return (
    <SideMenu.LinkItem
      active={isActive}
      href={path}
      analyticsProps={sideNavAnalyticsProps({
        href: path,
        title,
      })}
      icon={GraduationCap}
      data-element-id="side-nav-career-coach-link"
    >
      {title}
    </SideMenu.LinkItem>
  )
})
